export const GET_STATS = `
query {
  admin: administratorInfo{
    organization {
      name
    }
  }
  statistics {
    group_ids
    active_groups
    total_members
    total_active_members
    total_inactive_members
    active_30_days_users
    total_training_activities
    total_training_sessions
    total_weekly_reflections
				total_feed_forwards
				completed_feed_forwards
    weekly_avg
    feed_forward_habit_index_avg
    feed_forward_last90days_habit_index_avg
    feed_forward_trust_nps
    feed_forward_last90days_trust_nps_avg
    feed_forward_last90days_total_records
    practiced_areas
    practiced_loops {
      loop_id
      loop_title
      loop_count
      area_id
      area_name
    }
    feed_forward_top_requested {
      loop_id
      loop_title
    }
    feed_forward_top_satisfied {
      loop_id
      loop_title
    }
    journey_sessions {
      count
      no_of_session
    }
    weekly_trend {
      year
      week
      training_sessions
      active_users
    }
    effect_survey {
      type
      no_of_yes
      no_of_no
    }
    feed_forward_quarterly_stats {
      year
      quarter
      total_lhp_records
      trust_nps_avg
      habit_index_avg
    }
  }
}`;

export const GET_COMPARED_GROUPS = `
query($groupIds: [Int!]!){
  compare(groupIds: $groupIds)
}`;

export const FETCH_GROUP_IDS = `
query {
  groups {
    id: group_id
  }
}`;

export const GET_GROUP_DETAIL = `
query($groupIds: [Int!]!) {
  groupMembers(keyword: null, size: 1000, offset: 0, groupIds: $groupIds) {
    name
    email
    created_at
    activate_at
    status
    membership {
      valid_days
      type
    }
    access_code
  }
  statistics(groupIds: $groupIds) {
    group_ids
    active_groups
    total_members
    total_active_members
    total_inactive_members
    active_30_days_users
    active_30_days_user_emails
    total_training_activities
    total_training_sessions
    total_weekly_reflections
				total_feed_forwards
				completed_feed_forwards
    weekly_avg
				feed_forward_last90days_total_records
	feed_forward_habit_index_avg
	feed_forward_trust_nps
    practiced_areas
    practiced_loops {
      loop_id
      loop_title
      loop_count
      area_id
      area_name
    }
    journey_sessions {
      count
      no_of_session
    }
    feed_forward_top_requested {
      loop_id
      loop_title
    }
    feed_forward_top_satisfied {
      loop_id
      loop_title
    }
    weekly_trend {
      year
      week
      training_sessions
      active_users
    }
    effect_survey {
      type
      no_of_yes
      no_of_no
    }
    feed_forward_quarterly_stats {
      year
      quarter
      total_lhp_records
      trust_nps_avg
      habit_index_avg
    }
  }
}`;

export const CREATE_GROUP = `
mutation($country: String!, $description: String!, $name: String!) {
  createGroup(country: $country, description: $description, name: $name)
}`;
